<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Body-Text" style="margin-top:2em;">Thrice tosse these Oaken ashes in the ayre,</p>
<p class="ORIM-Body-Text">Thrice sit thou mute in this inchanted chayre;</p>
<p class="ORIM-Body-Text">Then thrice three times tye up this true loves knot,</p>
<p class="ORIM-Body-Text">And murmur soft, shee will, or shee will not.</p>
<p class="ORIM-Body-Text" style="margin-top:20px;">Goe burn these poys’nous weedes in yon blew fire,</p>
<p class="ORIM-Body-Text">These Screech-owles fethers, and this prickling bryer,</p>
<p class="ORIM-Body-Text">This Cypresse gathered at a dead mans grave:</p>
<p class="ORIM-Body-Text">That all thy feares and cares an end may have.</p>
<p class="ORIM-Body-Text" style="margin-top:20px;">Then come, you Fayries, dance with me a round,</p>
<p class="ORIM-Body-Text">Melt her hard heart with your melodious sound.</p>
<p class="ORIM-Body-Text">In vaine are all the charmes I can devise:</p>
<p class="ORIM-Body-Text">She hath an Arte to breake them with her eyes.</p>
<p class="ORIM-Body-Text" style="margin-top:20px;">—Thomas Campion, 1617</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled12.vue?210d9443